import React from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function PlannedQtySummaryCard({ plannedQtyData = [] }) {
  return (
    <Box display="flex" mt={2} justifyContent="flex-end">
      <Card
        elevation={0}
        sx={{
          borderRadius: "8px",
          backgroundColor: "transparent",
          minWidth: 450,
        }}
      >
        <CardContent sx={{ p: 1.5 }}>
          {/* Title */}
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            fontSize="0.85rem"
            gutterBottom
          >
            Planned Qty Summary
          </Typography>
          <Divider sx={{ mb: 1 }} />

          {/* Table */}
          <TableContainer>
            <Table size="small" aria-label="planned qty summary">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Ship To Area</TableCell>
                  <TableCell align="center">Ship To City</TableCell>
                  <TableCell align="center">Ship To State</TableCell>
                  <TableCell align="center">Total Qty</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {plannedQtyData.length > 0 ? (
                  plannedQtyData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.ShipToArea}</TableCell>
                      <TableCell align="center">{row.ShipToCity}</TableCell>
                      <TableCell align="center">{row.ShipToState}</TableCell>
                      <TableCell align="center">{row.TotalQty}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={4}>
                      No summary available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}
